import { useId } from 'react';

/* Settings row, after the prototype's switch rows: title + help on the left, the control on the right. Lives inside a
   `.form-section`; shared by Settings and the connection dialogs. */
export function Row({ title, desc, children }) {
  const id = useId();
  return (
    <div className="settings-row" role="group" aria-labelledby={`${id}-title`} aria-describedby={desc ? `${id}-description` : undefined}>
      <div>
        <h3 id={`${id}-title`}>{title}</h3>
        {desc && <p id={`${id}-description`}>{desc}</p>}
      </div>
      <div>{children}</div>
    </div>
  );
}
